import styled from 'styled-components';
export const StyledSearchControls = styled.div.withConfig({
  displayName: "StyledSearchControls",
  componentId: "vbrfiv-0"
})(["flex-flow:row nowrap;", " display:flex;align-items:center;justify-content:center;pointer-events:", ";"], ({
  isOpen,
  hasValue
}) => (hasValue || !hasValue && !isOpen) && `
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 12px;
  `, ({
  hasValue
}) => hasValue ? 'initial' : 'none');